import { ProductOnboardingStepState } from '../../graphql/schema';
import { addAccountUrl } from '../../Shared/addAccountUrl';
import { urlBuilder } from '../../Shared/urlBuilder';

export type BundleStep = {
  id: string;
  shortDescription: string;
  state: ProductOnboardingStepState;
};

export type ProductOnboardingOption = {
  id: string;
  name: string;
};

export type Bundle = {
  slug: string;
  steps: BundleStep[];
  productOnboardingOptions: ProductOnboardingOption[];
};

export const getBundleResumeUrl = (bundle: Bundle): string => {
  const { slug, steps, productOnboardingOptions } = bundle;

  if (steps[0]?.state === ProductOnboardingStepState.Active) {
    return urlBuilder.appProfileSetupFlow.absolute({ bundle_category: slug });
  }

  const firstProductStep = steps[1];
  const secondProductStep = steps[2];

  const incompleteProductCount = [firstProductStep, secondProductStep].filter(
    step => step?.state !== ProductOnboardingStepState.Finished
  ).length;
  const shouldUseBundle = incompleteProductCount > 1;

  if (firstProductStep?.state === ProductOnboardingStepState.Active) {
    return addAccountUrl({
      product_category: productOnboardingOptions[0].id,
      resume: 'true',
      ...(shouldUseBundle && { bundle: 'true' }),
    });
  }

  if (secondProductStep?.state === ProductOnboardingStepState.Active) {
    return addAccountUrl({
      product_category: productOnboardingOptions[1].id,
      resume: 'true',
      ...(shouldUseBundle && { bundle: 'true' }),
    });
  }

  if (steps[3]?.state === ProductOnboardingStepState.Active) {
    return urlBuilder.appDepositSetup.absolute();
  }

  return addAccountUrl({
    product_category: productOnboardingOptions[0].id,
    bundle: 'true',
    resume: 'true',
  });
};
